import { useEffect, useState } from 'react'
import { Badge, Container, SpaceBetween } from '@amzn/awsui-components-react/polaris'
import useStore from '../../Store'
import { BADGE_COLOR } from '../../Constant'
import { Link } from '@amzn/awsui-components-react'
import { useNavigate } from 'react-router-dom'
import HistoryHeader from './HistoryHeader'
import { GridApi } from 'ag-grid-community'
import { createAllocationEmptyState, getHistoryColumnDefs } from './HistoryUtils'
import GenericAGGridTable from '../grid/GenericAGGridTable'

const HistoryTable = (props) => {
    const {
        isLoading,
        onHistoryLoadingChange,
        isTeamActive,
        onIsTeamActiveChange,
        isTeamSelected,
        teamId,
    } = props

    const selectedTeam = useStore((state) => state.selectedTeam)
    const setSelectedAllocationReportToCopy = useStore(
        (state) => state.setSelectedAllocationReportToCopy,
    )
    const historyAllocationReports: any[] = useStore((state) => state.historyAllocationReports)
    const setHistoryDateRange = useStore((state) => state.setHistoryDateRange)
    const setHistoryCopyAheadOverrideWeeks = useStore(
        (state) => state.setHistoryCopyAheadOverrideWeeks,
    )

    const navigate = useNavigate()
    const [gridApi, setGridApi] = useState<GridApi>()

    const allocationWeekCellRenderer = (params) => (
        <SpaceBetween size='s' direction='horizontal'>
            <Link
                onFollow={(event) => {
                    event.preventDefault()
                    navigate(`/allocation/${selectedTeam.value}/${params.value}`)
                }}
                href={`/allocation/${selectedTeam.value}/${params.value}`}
            >
                {params.value}
            </Link>
            {params.data.badge ? <Badge color={BADGE_COLOR.RED}>{params.data.badge}</Badge> : <></>}
        </SpaceBetween>
    )
    const columnDefs = getHistoryColumnDefs(allocationWeekCellRenderer)

    const onSelectionChanged = (event) => {
        setSelectedAllocationReportToCopy(event.api.getSelectedRows())
        setHistoryCopyAheadOverrideWeeks([])
        setHistoryDateRange('')
    }

    useEffect(() => {
        if (isLoading) {
            gridApi?.showLoadingOverlay()
        } else {
            gridApi?.setGridOption('rowData', historyAllocationReports)
        }
    }, [gridApi, historyAllocationReports, isLoading])

    return (
        <Container
            fitHeight
            header={
                <HistoryHeader
                    gridApi={gridApi}
                    isLoading={isLoading}
                    onHistoryLoadingChange={onHistoryLoadingChange}
                    isTeamActive={isTeamActive}
                    onIsTeamActiveChange={onIsTeamActiveChange}
                    isTeamSelected={isTeamSelected}
                    teamId={teamId}
                />
            }
        >
            <GenericAGGridTable
                setGridApi={setGridApi}
                colDefs={columnDefs}
                onSelectionChanged={onSelectionChanged}
                noRowsOverlayComponent={createAllocationEmptyState(true)}
                includeTableHeader={false}
                actionDropdownPermission={true}
            />
        </Container>
    )
}

export default HistoryTable
